export default __webpack_public_path__ + "static/media/system-volume-04.c685d851.svg";